import {IModalServiceInstance} from 'angular-ui-bootstrap';
import ITranslateService = angular.translate.ITranslateService;

export class YesNoController {

    static $inject = ['$uibModalInstance', '$translate', 'title', 'text'];

    title: string;
    text: string;

    constructor(private $uibModalInstance: IModalServiceInstance, $translate: ITranslateService, title: string, text: string) {
        if (text !== undefined && text !== null) {
            this.text = $translate.instant(text);
        } else {
            this.text = 'test';
        }
        if (title !== undefined && title !== null) {
            this.title = $translate.instant(title);
        } else {
            this.title = 'Confirmation';
        }
    }

    yes(): void {
        this.$uibModalInstance.close();
    };

    no(): void {
        this.$uibModalInstance.dismiss('cancel');
    };
}



// WEBPACK FOOTER //
// ./src/app/core/dialog/YesNoController.ts